class BracingDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('configure-bracing-dialog', async () => this.configure(), true)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  configure() {
    document.getElementById('equal-bracing-form').classList.add('hidden')
    document.getElementById('custom-bracing-form').classList.add('hidden')

    this.resetButton('continuous-bracing-button')
    this.resetButton('equally-spaced-bracing-button')
    this.resetButton('custom-bracing-button')
    this.resetButton('unbraced-bracing-button')
    
    if(activeProject.design.bracingType === 'continuous') {
      document.getElementById('continuous-bracing-button').classList.add('btn-primary')  
    } else if (activeProject.design.bracingType === 'equal') {
      document.getElementById('equal-bracing-form').classList.remove('hidden')
      document.getElementById('equally-spaced-bracing-button').classList.add('btn-primary')  
      updateEquallySpacedBracingForm()
    } else if (activeProject.design.bracingType == 'custom') {
      document.getElementById('custom-bracing-form').classList.remove('hidden')
      document.getElementById('custom-bracing-button').classList.add('btn-primary')  
      updateCustomBracingTable();
    } else if (activeProject.design.bracingType == 'unbraced') {
      document.getElementById('unbraced-bracing-button').classList.add('btn-primary')  
    }
  }

  onBracingButtonClick(id) {

    let idMap = {
      'continuous-bracing-button': 'continuous',
      'equally-spaced-bracing-button': 'equal',
      'custom-bracing-button': 'custom',
      'unbraced-bracing-button': 'unbraced'
    }

    activeProject.beamController.updateBracingType(idMap[id])

    this.configure()

    $("#modal-bracing-dialog").trigger( 'ws_redraw' );
    $('#modal-bracing-dialog').trigger( 'bracing-type-changed' );
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div class="modal-body modal-body-shadow text-center" style="background:#F8F8F8">
      <button class="btn btn-primary button-shadow" id='continuous-bracing-button'>Continuous Bracing</button>
      <button class="btn btn-default button-shadow" id='equally-spaced-bracing-button'>Equally Spaced</button>
      <button class="btn btn-default button-shadow" id='custom-bracing-button'>Custom</button>
      <button class="btn btn-default button-shadow" id='unbraced-bracing-button'>Completely Unbraced</button>
    </div>

    <div class="modal-body">
      <form id="equal-bracing-form">
        <table class="table" id="equal-bracing-table">
          <tr class="success">
            <td style='width:100px;'>Spacing @:</td>
            <td><input style='width:100px;' id='equal-bracing-spacing-input' type='text'
                name='equal-bracing-spacing-input' value='0' />
              O.C.</td>
          </tr>
          <tr class="success">
            <td style='width:100px;'>Starting @:</td>
            <td><input style='width:100px;' id='equal-bracing-start-input' type='text'
                name='equal-bracing-start-input' value='0' />
              from left end</td>
          </tr>
        </table>
      </form>
    
      <form id="custom-bracing-form" name="custom-bracing-form">
        <table class="table">
          <tr class="success">
            <td style="width:120px;">New Brace @:</td>
            <td><input style="width:100px;" id="new-brace-location-input" type="text"
                name="new-brace-location-input" value='0"'></td>
            <td><button id="add-brace-button" type="button" class="btn btn-sm btn-success"
                onclick="addBrace()">Add</button>
            </td>
          </tr>
        </table>
        <div id="custom-bracing-table"></div>
      </form>
    </div>
    `

    document.getElementById('continuous-bracing-button').onclick = (() => this.onBracingButtonClick('continuous-bracing-button'))
    document.getElementById('equally-spaced-bracing-button').onclick = (() => this.onBracingButtonClick('equally-spaced-bracing-button'))
    document.getElementById('custom-bracing-button').onclick = (() => this.onBracingButtonClick('custom-bracing-button'))
    document.getElementById('unbraced-bracing-button').onclick = (() => this.onBracingButtonClick('unbraced-bracing-button'))

    jQuery.validator.addMethod("validBraceSpacing", function(value) {
      var spacing = wsParseLength(value);
      return !isNaN(spacing) && spacing > 0 && spacing <= activeProject.beam.TotalLength();
    }, "Brace spacing must be larger than 0 and less than or equal to the total length of the beam.");

    jQuery.validator.addMethod("validBraceLocation", function(value) {
      var spacing = wsParseLength(value);
      return !isNaN(spacing) && spacing >= 0 && spacing <= activeProject.beam.TotalLength();
    }, "Brace location must be greater than or equal to 0 and less than or equal to the total length of the beam.");

    $( "#equal-bracing-form" ).validate({
      rules: {
        'equal-bracing-spacing-input': {
            required: true,
            validLengthUnit: true,
            validBraceSpacing: true
        },
        'equal-bracing-start-input' : {
            required: true,
            validLengthUnit: true,
            validBraceLocation: true
        },
      }
    })

    $( "#custom-bracing-form" ).validate({
      rules: {
        'new-brace-location-input': {
            required: true,
            validLengthUnit: true,
            validBraceLocation: true
        }
      }
    });

    this.configure()
  }
}

customElements.define('bracing-dialog-component', BracingDialogComponent)

